import { Scene } from "three";
class SceneManager {
    scene;
    static instance;
    /**
     * SceneManager manages the Scene object.
     * @private
     */
    constructor() {
        this.scene = this.buildScene();
    }
    /**
     * Create and configure a Scene object.
     * @returns the created Scene object.
     * @private
     */
    buildScene() {
        const scene = new Scene();
        return scene;
    }
    get getScene() {
        return this.scene;
    }
    static getInstance() {
        if (!SceneManager.instance)
            SceneManager.instance = new SceneManager();
        return SceneManager.instance;
    }
}
export default SceneManager;
